import { render, staticRenderFns } from "./StudentProfileCard.vue?vue&type=template&id=3160d25a&scoped=true"
import script from "./StudentProfileCard.vue?vue&type=script&lang=js"
export * from "./StudentProfileCard.vue?vue&type=script&lang=js"
import style0 from "./StudentProfileCard.vue?vue&type=style&index=0&id=3160d25a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3160d25a",
  null
  
)

export default component.exports